import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { PaymentElement } from '@stripe/react-stripe-js';
import { withTranslation } from 'react-i18next';

class UpdatePaymentOptionForm extends Component {
	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleSubmit() {
		const { onSubmit, stripe, elements, payment } = this.props;
		onSubmit(stripe, elements, payment);
	}

	render() {
		const { payment, error, t } = this.props;
		return <div>
			{payment && payment.parent && <div>
				{error && <div className='alert alert-danger'>{error}</div>}
				<PaymentElement
					options={{
						defaultValues: {
							billingDetails: {
								email: payment.parent.email,
								name: payment.parent.fullName,
								phone: payment.parent.phoneNumber
							}
						}
					}}
				/>
				<Button bsStyle='primary' className='pull-right' onClick={this.handleSubmit}>{t('FO_Booking_Confirm')}</Button>
				<div className='clearfix' />
			</div>}
		</div>;
	}
}

export default withTranslation()(UpdatePaymentOptionForm);